import { BundleDetails } from './bundles.types';
import { NationalProgramStates } from './nationalProgram.types';

export enum FreezeType {
  MAINTENANCE = 'MAINTENANCE',
  NATIONAL_PROGRAM = 'NATIONAL_PROGRAM',
  HOLIDAY = 'HOLIDAY',
  GLOBAL_FREEZE = 'GLOBAL_FREEZE',
}

// this type includes data for both maintenance and national program freezes
export interface Freeze {
  id: string;
  bundleId: string;
  name: string;
  optInStartDate: string;
  startDate: string;
  endDate: string;
  nationalDefaultPrice: number;
  hagDefaultPrice: number;
  nationalPricePoints: number[];
  hagPricePoints: number[];
  optOutHidden: boolean;
  redeemableOnline: boolean;
  visibleOnline: boolean;
  freezeType: FreezeType;
  state: NationalProgramStates;
  optInProgressPercent: number | null;
  bundleData?: BundleDetails;
}

export interface GlobalFreeze {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  live: boolean;
}

export interface UpsertGlobalFreezeDto {
  name: string;
  startDate: string;
  endDate: string;
}
